import React from 'react';
import ButtonDelete from '../ButtonDelete';
import './index.less';
export default function DeletableBlock(props) {
  const {
    title,
    children,
    index,
    onDelete,
    deletable,
    content,
    headerClassName
  } = props;
  return /*#__PURE__*/React.createElement("div", {
    className: "cc-delete-block"
  }, /*#__PURE__*/React.createElement(ButtonDelete, {
    content: content,
    showDelete: deletable,
    left: title,
    onDelete: () => onDelete(index),
    headerClassName: headerClassName
  }), children);
}